import { graphqlClient } from '@/lib/graphql-client';
import { buildGetPmFormsQuery } from '../graphql/queries';
import {
  DELETE_PM_FORM_MUTATION,
  INSERT_PM_FORM_MUTATION,
  UPDATE_PM_FORM_MUTATION,
} from '../graphql/mutations';
import {
  GetPmFormsParams,
  PmFormInsertInput,
  PmFormsPagingResult,
  PmFormUpdateInput,
} from '../types/form.types';

const byId = (itemId: string) => JSON.stringify({ _id: itemId });

export const getPmForms = async (
  params: GetPmFormsParams
): Promise<{ PmForms: PmFormsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetPmFormsQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ PmForms: PmFormsPagingResult }>;
};

export const getPmFormById = async (itemId: string): Promise<{ PmForms: PmFormsPagingResult }> =>
  graphqlClient.query({
    query: buildGetPmFormsQuery({ ItemId: itemId }, 1, 1),
  });

export const createPmForm = async (input: PmFormInsertInput) =>
  graphqlClient.mutate({ query: INSERT_PM_FORM_MUTATION, variables: { input } });

export const updatePmForm = async (params: { itemId: string; input: PmFormUpdateInput }) =>
  graphqlClient.mutate({
    query: UPDATE_PM_FORM_MUTATION,
    variables: { filter: byId(params.itemId), input: params.input },
  });

/** Soft delete (Blocks native): existing review submissions keep their own PmForm snapshot. */
export const deletePmForm = async (itemId: string) =>
  graphqlClient.mutate({
    query: DELETE_PM_FORM_MUTATION,
    variables: { filter: byId(itemId), input: { isHardDelete: false } },
  });
